import { memo } from 'react';

/**
 * Reusable Card Component
 * Memoized to prevent unnecessary re-renders
 */

const Card = memo(function Card({
  children,
  onClick,
  selected = false,
  selectable = false,
  className = '',
}) {
  const baseStyles = 'p-6 rounded-2xl border-4 transition-all';
  const selectableStyles = selectable
    ? 'cursor-pointer transform hover:scale-105'
    : '';
  const selectedStyles = selected
    ? 'bg-green-100 border-green-500 shadow-lg'
    : 'bg-gray-50 border-gray-300 hover:bg-gray-100';

  return (
    <div
      onClick={onClick}
      className={`${baseStyles} ${selectableStyles} ${selectedStyles} ${className}`}
    >
      {children}
    </div>
  );
});

export default Card;
